const STATISTICS_SHOT_COUNT_FILTER_PREFIX = "statisticsShotCountFilter";

export function getRememberedStatisticsShotCount(shootingEventId: string): string {
  if (!shootingEventId) {
    return "";
  }

  try {
    return localStorage.getItem(getStorageKey(shootingEventId)) ?? "";
  } catch (error) {
    console.error("Failed to read statistics shot count filter", error);
    return "";
  }
}

export function rememberStatisticsShotCount(shootingEventId: string, shotCount: string): void {
  if (!shootingEventId) {
    return;
  }

  try {
    if (shotCount) {
      localStorage.setItem(getStorageKey(shootingEventId), shotCount);
    } else {
      clearRememberedStatisticsShotCount(shootingEventId);
    }
  } catch (error) {
    console.error("Failed to save statistics shot count filter", error);
  }
}

export function clearRememberedStatisticsShotCount(shootingEventId: string): void {
  if (!shootingEventId) {
    return;
  }

  try {
    localStorage.removeItem(getStorageKey(shootingEventId));
  } catch (error) {
    console.error("Failed to clear statistics shot count filter", error);
  }
}

function getStorageKey(shootingEventId: string): string {
  return `${STATISTICS_SHOT_COUNT_FILTER_PREFIX}:${shootingEventId}`;
}

